{
    "smartTasks": {
        "tourLabel": "Tâches intelligentes",
        "learn": "Apprenez à générer, réécrire et traduire du texte avec Cephable.",
        "generate": {
            "openTool": {
                "title": "Ouvrir l'outil de génération de texte",
                "description": "Dans le panneau Cephable, cliquez sur la carotte à côté de Tâches intelligentes et sélectionnez Générer du texte."
            },
            "enterPrompt": {
                "title": "Entrez l'invite",
                "description": "Dans la boîte de dialogue, saisissez : Créez un jeu de mots en une seule phrase crédible."
            },
            "clickGenerate": {
                "title": "Cliquez sur Générer",
                "description": "Cliquez sur le bouton « Générer ». Regardez le texte apparaître en temps réel."
            },
            "focusApp": {
                "title": "Concentrez-vous sur l'application",
                "description": "Assurez-vous de sélectionner l'application où vous souhaitez que le texte généré apparaisse. Vous pourrez générer le texte à cet endroit en toute simplicité en cliquant sur « Générer »."
            }
        },
        "rewrite": {
            "welcome": {
                "title": "Bienvenue à Rewrite",
                "description": "Reformulez rapidement le contenu avec du texte surligné ou collé."
            },
            "highlightToggle": {
                "title": "Utiliser le texte en surbrillance",
                "description": "Assurez-vous que « Utiliser le texte en surbrillance » est sélectionné (par défaut)."
            },
            "highlightText": {
                "title": "Surligner le texte à réécrire",
                "description": "Point fort : une pieuvre peut contrôler chaque bras indépendamment."
            },
            "enterInstructions": {
                "title": "Entrez les instructions de réécriture",
                "description": "Type : Dans un style anglais ancien."
            },
            "clickGenerate": {
                "title": "Cliquez sur Générer",
                "description": "Votre texte surligné sera réécrit en fonction de votre saisie."
            },
            "pasteMode": {
                "title": "Utiliser Coller du texte",
                "description": "Collez l'original et réécrivez les instructions. Cliquez sur « Générer ». Cliquez sur « Effacer » pour réinitialiser."
            },
            "openTool": {
                "title": "Ouvrir l'outil de réécriture de texte",
                "description": "Dans le panneau Cephable, cliquez sur la carotte à côté de Tâches intelligentes et sélectionnez Réécrire le texte."
            },
            "focusApp": {
                "title": "Concentrez-vous sur l'application",
                "description": "Assurez-vous de sélectionner l'application où vous souhaitez que le texte réécrit apparaisse. Vous pourrez générer facilement le texte à cet endroit en cliquant sur « Générer »."
            }
        },
        "translate": {
            "welcome": {
                "title": "Bienvenue sur Translate",
                "description": "Traduisez le texte surligné ou collé dans une autre langue."
            },
            "highlightToggle": {
                "title": "Utiliser le texte en surbrillance",
                "description": "Assurez-vous que « Utiliser le texte en surbrillance » est sélectionné."
            },
            "highlightText": {
                "title": "Surligner le texte à traduire",
                "description": "Point fort : une pieuvre peut contrôler chaque bras indépendamment."
            },
            "enterLanguage": {
                "title": "Entrez la langue cible",
                "description": "Type : Portugais."
            },
            "clickGenerate": {
                "title": "Cliquez sur Générer",
                "description": "La traduction sera saisie dans votre application au niveau de votre curseur."
            },
            "pasteMode": {
                "title": "Utiliser Coller du texte",
                "description": "Collez le texte et la langue. Cliquez sur « Générer ». Cliquez sur « Effacer » pour réinitialiser."
            },
            "openTool": {
                "title": "Ouvrir l'outil de traduction de texte",
                "description": "Dans le panneau Cephable, cliquez sur la carotte à côté de Tâches intelligentes et sélectionnez Traduire le texte."
            }
        },
        "rowDescription": "Les tâches intelligentes sont les différentes tâches que l'IA de Cephable peut effectuer pour vous. Ces tâches, alimentées par l'IA intégrée à l'appareil, peuvent être utilisées pour créer du texte, résumer, réécrire, traduire, et bien plus encore."
    },
    "overview": {
        "title": "Aperçu",
        "description": "Cephable est votre IA personnelle : conçue pour des actions rapides, des commandes vocales, la génération de contenu et une automatisation intelligente de vos outils. Des commandes prêtes à l'emploi. Aucun traitement cloud. Juste une productivité qui vous accompagne."
    },
    "customControls": {
        "tourLabel": "Contrôles globaux et des appareils toujours disponibles",
        "rowDescription": "Les commandes globales et celles de l'appareil sont toujours disponibles si votre microphone est activé, quelle que soit l'application utilisée. Vous pouvez utiliser ces commandes pour interagir avec votre appareil sans avoir à créer de nouvelles commandes. Elles contiennent des commandes utiles comme changer de commande ou d'application, générer du texte, mettre votre microphone en pause, et bien plus encore."
    },
    "profile": {
        "tourLabel": "Contrôles de l'application",
        "learn": "Découvrez comment configurer les contrôles et les préférences de votre application dans Cephable.",
        "rowDescription": "Les commandes d'application sont des ensembles de commandes configurées que vous pouvez utiliser pour exécuter des actions. Vous souhaitez dire « Diapositive suivante » pour passer à la diapositive suivante de votre présentation ? Ou utiliser les mouvements de la tête pour déplacer le curseur et les commandes vocales pour modifier les raccourcis ? C'est possible avec les commandes d'application. La ligne « Commandes » affiche toutes les commandes disponibles pour votre application actuelle.",
        "check": {
            "title": "Vérifiez vos commandes disponibles.",
            "description": "Les commandes d'application sont disponibles pour chaque application que vous utilisez. Vous pouvez voir ici les commandes disponibles pour l'application que vous utilisez actuellement. Essayez une autre commande pour voir son fonctionnement. Assurez-vous toutefois de vous concentrer sur l'application que vous souhaitez contrôler."
        }
    },
    "dictation": {
        "tourLabel": "Dictée",
        "learn": "Apprenez à utiliser le mode dictée pour convertir votre discours en texte en mains libres.",
        "welcome": {
            "title": "Dictée",
            "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
        },
        "microphone": {
            "title": "Allumez votre microphone",
            "description": "Tout d'abord, activez votre microphone. Cliquez sur l'icône « Microphone » dans le panneau Cephable."
        },
        "activate": {
            "title": "Démarrer le mode dictée",
            "description": "La voix démarre en mode commande. Pour lancer la dictée, dites « Démarrer la dictée » ou cliquez sur le bouton « Dictée ». Activons maintenant le mode dictée."
        },
        "focus": {
            "title": "Se concentrer sur un champ de texte ou un document",
            "description": "La dictée est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur le champ de texte ou le document où vous souhaitez dicter."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous êtes concentré. Essayez de dire quelque chose comme : « Bonjour, ceci est un test du mode dictée. »"
        },
        "pauseResume": {
            "title": "Pause de la dictée",
            "description": "Besoin d'une pause sans désactiver la dictée ? Dites simplement « Suspendre la dictée ». Vous pouvez la reprendre à tout moment avec « Démarrer la dictée ». Vous pouvez personnaliser davantage cette option grâce aux commandes globales et aux commandes de l'appareil toujours actives."
        },
        "stop": {
            "title": "Arrêter la dictée",
            "description": "Besoin de revenir aux commandes de votre application ? Dites simplement « Arrêter la dictée ». Cela arrêtera le mode dictée et vous ramènera au mode commande. Vous pouvez reprendre à tout moment en cliquant à nouveau sur « Démarrer la dictée »."
        },
        "complete": {
            "description": "Et voilà ! Vous pouvez désormais dicter, mettre en pause, reprendre et passer du mode dictée au mode commande. La dictée est un outil puissant pour la saisie mains libres. Utilisez-la pour rédiger des e-mails, des documents ou tout ce que vous devez saisir à voix haute."
        }
    },
    "camera": {
        "tourLabel": "Commandes de la caméra",
        "rowDescription": "Les commandes de l'appareil photo vous permettent d'utiliser votre visage et votre corps pour contrôler votre appareil. Vous pouvez utiliser différentes expressions faciales et mouvements de tête pour contrôler votre appareil. Avec le microphone activé, vous pouvez utiliser des commandes vocales pour démarrer et arrêter l'appareil photo, et changer de caméra.",
        "learn": "Apprenez à utiliser les commandes de l’appareil photo pour naviguer et interagir avec votre appareil en mains libres.",
        "welcome": {
            "title": "Commandes de la caméra",
            "description": "Les commandes de l'appareil photo vous permettent d'utiliser votre visage et votre corps pour contrôler votre appareil. Vous pouvez utiliser différentes expressions faciales, mouvements de tête et commandes vocales pour naviguer et interagir avec votre appareil en mode mains libres."
        },
        "start": {
            "title": "Démarrer les commandes de la caméra",
            "description": "Pour commencer à utiliser les commandes de la caméra si vous utilisez la voix, dites « Démarrer les commandes de la caméra » ou cliquez sur le bouton Commandes de la caméra."
        }
    },
    "microphone": {
        "tourLabel": "Commandes vocales",
        "learn": "Découvrez comment utiliser votre voix pour contrôler n’importe quelle application et utiliser la dictée pour taper ce que vous dites.",
        "description": "Les commandes vocales Cephable vous permettent d'utiliser votre voix pour contrôler votre appareil. Vous souhaitez enregistrer un document ? Dites simplement « Enregistrer ». Vous souhaitez mettre votre musique en pause ? Dites simplement « Pause ». La voix vous permet également d'utiliser la dictée vocale pour saisir ce que vous dites.",
        "rowDescription": "Lorsque le microphone est désactivé, nous n'entendons pas vos commandes vocales. Cependant, si vous l'activez, vous pourrez utiliser les commandes globales pour mettre en pause, démarrer, etc. Allumons-le.",
        "start": {
            "title": "Démarrer les commandes vocales",
            "description": "Pour commencer à utiliser les commandes vocales, cliquez sur l'interrupteur « Microphone » dans le panneau Cephable. Cela activera le microphone et commencera à écouter les commandes."
        },
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Spotify » ou « Ouvrir Word »",
            "description": "« Ouvrir » est une commande globale qui ouvre l'application spécifiée et lui donne le focus. Si le changement automatique de contrôle est activé, la commande basculera également vers les contrôles d'application les plus adaptés à l'application que vous utilisez."
        },
        "finishedCommands": {
            "title": "Excellent ! Vous avez appris les bases des commandes vocales.",
            "description": "Vous pouvez toujours consulter la visite depuis la page d'assistance. L'étape suivante consiste à découvrir la dictée. Vous pouvez commencer la visite depuis la page d'assistance."
        }
    },
    "publicProfiles": {
        "tourLabel": "Personnaliser les contrôles de l'application"
    },
    "tour": {
        "title": "Bienvenue chez Cephable",
        "description": "Cephable est un outil puissant qui vous permet de contrôler votre ordinateur avec votre voix, votre caméra et d'autres commandes. Cette visite vous guidera à travers ses principales fonctionnalités et vous expliquera comment les utiliser efficacement.",
        "startTour": "Démarrer la visite",
        "finishTour": "Terminer la tournée",
        "statusDialog": "Veuillez consulter le panneau pour plus d'informations.",
        "step": "Étape {{step}} sur {{total}}",
        "next": "Suivant",
        "previous": "Précédent",
        "endTour": "Fin de la tournée",
        "nextTourLabel": "Suivant : {{nextStepTitle}}",
        "skipTour": "Skip Tour",
        "steps": {
            "welcome": {
                "title": "Bienvenue chez Cephable",
                "description": "Cette visite vous guidera à travers les principales fonctionnalités de Cephable. C'est parti !"
            },
            "inputs": {
                "title": "Aperçu des entrées",
                "description": "Cephable prend en charge plusieurs méthodes de saisie, notamment les commandes vocales, les commandes de caméra, etc. Vous pouvez personnaliser ces saisies dans les paramètres."
            },
            "appControls": {
                "title": "Contrôles de l'application",
                "description": "Créez des contrôles d'application pour associer vos entrées à des actions spécifiques dans vos applications. Cela vous permet de contrôler vos applications par gestes, commandes vocales, etc."
            },
            "settings": {
                "title": "Paramètres",
                "description": "Accédez aux paramètres pour configurer vos entrées, les commandes de vos applications et autres préférences. Vous pouvez également gérer votre compte et vos paramètres de langue ici."
            },
            "intelligentTasks": {
                "title": "Tâches intelligentes",
                "description": "Utilisez des tâches intelligentes pour générer du texte, résumer du contenu, réécrire du texte, traduire des langues et bien plus encore à l'aide de fonctionnalités basées sur l'IA."
            },
            "cameraControls": {
                "title": "Commandes de la caméra",
                "description": "Activez les commandes de la caméra pour utiliser les expressions faciales et les mouvements de la tête comme méthodes de saisie pour contrôler votre ordinateur."
            },
            "voiceControls": {
                "title": "Commandes vocales",
                "description": "Utilisez les commandes vocales pour contrôler votre ordinateur en mains libres. Vous pouvez dicter du texte, émettre des commandes et interagir avec des applications grâce à votre voix."
            }
        }
    },
    "onboarding": {
        "demoPlaceholder": "Ceci est le texte de démonstration de l'espace réservé. À l'aide des instructions ci-dessus, vous pouvez contrôler le style de ce texte.",
        "exit": "Configuration de sortie",
        "overview": "Aperçu",
        "learn": "Découvrez les fonctionnalités de Cephable et comment les utiliser.",
        "start": "On dirait que vous ne faites que commencer. Voici quelques pistes pour vous aider.",
        "startTour": "Commencer",
        "dashboard": {
            "title": "Tableau de bord Cephable",
            "description": "Le tableau de bord Cephable est votre plateforme centrale pour gérer votre appareil, les commandes de vos applications et vos paramètres. De là, vous pouvez personnaliser votre expérience, consulter les commandes actives et accéder à toutes les fonctionnalités de Cephable."
        },
        "step1": {
            "title": "Bienvenue chez Cephable",
            "description": "Cephable est votre IA personnelle : conçue pour des actions rapides, des commandes vocales, la génération de contenu et une automatisation intelligente de vos outils. Des commandes prêtes à l'emploi. Aucun traitement cloud. Juste une productivité qui vous accompagne.",
            "inputs": "Que sont les entrées ?",
            "inputDescription": "Les commandes d'entrée sont les méthodes permettant d'utiliser votre appareil, étendant les capacités de votre ordinateur au-delà de la souris et du clavier traditionnels. Ces méthodes incluent les commandes vocales, les mouvements de la tête, les expressions faciales et les périphériques supplémentaires.",
            "profiles": "Que sont les contrôles d’application ?",
            "profileDescription": "Les commandes d'application vous permettent de vous connecter et de communiquer avec votre ordinateur de manière unique en associant les commandes d'entrée et de sortie. Grâce aux commandes d'application, vous pouvez demander à Cephable d'effectuer des tâches comme enregistrer un fichier en inclinant la tête ou cliquer sur « Envoyer » un e-mail avec un sourire.",
            "action": "Explorer les contrôles d'entrée",
            "secondaryAction": "Accéder aux commandes de l'application",
            "secondaryActionDescription": "Connaissez-vous déjà les contrôles d’entrée ?"
        },
        "finish": {
            "title": "Installation terminée",
            "description": "Vous avez utilisé avec succès vos premières commandes d'application Cephable ! Vous pouvez désormais les utiliser, et bien plus encore, sur votre appareil. Elles sont disponibles sur votre tableau de bord Cephable, où vous pouvez continuer à personnaliser les paramètres des commandes d'application selon vos besoins.",
            "continueToApp": "Continuer vers le tableau de bord Cephable",
            "keepExploring": "Continuez à explorer"
        },
        "useCaseSlider": {
            "context": "J'aimerais utiliser",
            "control": "contrôler"
        }
    },
    "support": {
        "tourLabel": "Prêt à en savoir plus ?",
        "description": "Vous pouvez visiter notre centre d'assistance pour plus d'informations sur l'utilisation de Cephable, notamment des visites guidées, des guides étape par étape, des didacticiels et des vidéos.",
        "cta": "Explorez d'autres circuits"
    },
    "featureFlag": {
        "title": "Il est temps de mettre à niveau",
        "description": "La fonctionnalité que vous essayez d'utiliser nécessite une licence différente. Effectuez une mise à niveau pour accéder à cette fonctionnalité et à bien d'autres."
    },
    "replyToSocialMedia": {
        "tourLabel": "Réponses plus rapides sur les réseaux sociaux grâce à la dictée",
        "learn": "Apprenez à utiliser la dictée pour répondre aux publications sur les réseaux sociaux en mains libres.",
        "navigateTo": {
            "title": "Accéder à une publication sur les réseaux sociaux",
            "description": "Ouvrez votre navigateur web et accédez à un réseau social comme LinkedIn ou Facebook. Trouvez la publication à laquelle vous souhaitez répondre."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous êtes concentré. Essayez de dire quelque chose comme « Félicitations ! Je suis ravi pour toi. » Assurez-vous que votre curseur est positionné sur un champ de texte ou une zone de commentaire."
        },
        "complete": {
            "description": "Et voilà ! Vous pouvez désormais utiliser les fonctions de dictée, de pause, de reprise et de basculement entre les modes dictée et commande pour répondre aux publications sur les réseaux sociaux en mode mains libres. La dictée est un outil puissant pour la saisie mains libres. Utilisez-la pour rédiger des e-mails, des documents ou tout ce que vous devez saisir à voix haute."
        }
    },
    "hotkeys": {
        "tourLabel": "Boutons d'action rapide",
        "learn": "Découvrez comment configurer des boutons d’action rapide pour associer plusieurs actions à un seul bouton.",
        "rowDescription": "Les boutons d'action rapide vous permettent d'effectuer plusieurs actions avec une seule commande. Par exemple, vous pouvez créer un bouton qui ouvre votre application musicale préférée et lance la lecture d'une playlist spécifique.",
        "check": {
            "title": "Vérifiez vos actions rapides disponibles.",
            "description": "Des boutons d'action rapide sont disponibles pour chaque application que vous utilisez. Vous pouvez voir ici les boutons disponibles pour l'application que vous utilisez actuellement. Essayez une autre commande pour voir son fonctionnement. Assurez-vous toutefois de vous concentrer sur l'application que vous souhaitez contrôler."
        }
    },
    "controllingBackgroundMusic": {
        "tourLabel": "Gérez la musique de fond sans interrompre votre flux",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour contrôler votre musique en mains libres, tout en restant concentré sur votre tâche en cours.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Spotify » ou « Ouvrir Apple Music »"
        },
        "play": {
            "title": "Essayez de dire « Play » pour commencer à jouer de la musique",
            "description": "Assurez-vous que votre microphone est activé et dites « Lecture ». La musique sera alors diffusée dans l'application musicale de votre choix. Cela fonctionne également avec toute autre application multimédia."
        },
        "newPlaylist": {
            "title": "Créer une nouvelle playlist",
            "description": "Assurez-vous que votre microphone est activé et dites « Nouvelle playlist ». Cela lancera la création d'une nouvelle playlist dans l'application musicale de votre choix."
        },
        "finishedCommands": {
            "title": "Bravo ! Vous avez appris à contrôler votre musique en mains libres.",
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, changer de piste et régler le volume dans vos applications musicales préférées. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour un contrôle musical encore plus fluide."
        }
    },
    "editingVideos": {
        "tourLabel": "Concentrez-vous sur l'histoire, pas sur les clics fastidieux du montage vidéo",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour éditer des vidéos plus rapidement et supprimez la charge cognitive liée à la mémorisation des boutons sur lesquels cliquer pendant l'édition.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir iMovie » ou « Ouvrir DaVinci Resolve »"
        },
        "play": {
            "title": "Essayez de dire « Play » pour commencer à lire votre vidéo",
            "description": "Assurez-vous que votre microphone est activé et dites « Lecture ». La lecture de votre vidéo commencera dans l'application de montage vidéo de votre choix."
        },
        "stop": {
            "title": "Arrêter la lecture vidéo",
            "description": "Assurez-vous que votre microphone est activé et dites « Stop ». Cela arrêtera la lecture de la vidéo dans l'application de montage vidéo de votre choix."
        },
        "finishedCommands": {
            "title": "Bravo ! Vous avez appris à contrôler votre montage vidéo en mains libres.",
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, changer de piste et régler le volume dans vos applications de montage vidéo préférées. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour un contrôle vidéo encore plus fluide."
        }
    },
    "vibeCoding": {
        "tourLabel": "Créez des idées, créez des prototypes et itérez plus rapidement avec la dictée",
        "learn": "Apprenez à utiliser la dictée et la génération de texte alimentée par l'IA pour créer du code, créer des prototypes et itérer sur des idées.",
        "navigateTo": {
            "title": "Accéder à un éditeur de code Vibe",
            "description": "Ouvrez votre navigateur web et accédez à un éditeur de code Vibe. Voici quelques exemples : Vercel V0, GitHub Copilot dans VS Code, Base 44 et Lovable."
        },
        "focus": {
            "title": "Cliquez sur « Nouvelle discussion » ou concentrez-vous sur une zone de texte.",
            "description": "La dictée est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur la zone de commentaire ou le fil de discussion où vous souhaitez dicter. Ensuite, commencez à parler."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous êtes concentré. Essayez d'énoncer vos exigences techniques et ce que le code doit faire. Assurez-vous que votre curseur est positionné sur un champ de texte ou une zone de commentaire."
        },
        "rewriteIntro": {
            "title": "Réécrire le code avec des instructions",
            "description": "Vous pouvez également utiliser des tâches intelligentes comme la réécriture pour modifier le code existant. Cette tâche est optimisée par l'IA intégrée à l'appareil, ce qui signifie qu'elle fonctionne sans connexion Internet et s'exécute directement depuis votre appareil."
        },
        "highlightText": {
            "title": "Surligner le texte à réécrire",
            "description": "Mettez en surbrillance le code que vous souhaitez réécrire."
        },
        "enterInstructions": {
            "title": "Entrez les instructions de réécriture",
            "description": "Saisissez vos instructions de réécriture de code. Précisez le langage de programmation, le style ou toute modification spécifique souhaitée."
        },
        "complete": {
            "description": "Et voilà ! Vous pouvez désormais dicter, mettre en pause, reprendre et itérer sur du code. Explorez d'autres cas d'utilisation avec la dictée et les tâches intelligentes, ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "documentCode": {
        "tourLabel": "Documentation de code rapide et sécurisée avec génération de texte IA sur l'appareil",
        "learn": "Découvrez comment utiliser la réécriture alimentée par l'IA pour documenter le code tout en restant dans la même application et en gardant vos données en sécurité.",
        "rewriteIntro": {
            "title": "Rédiger la documentation du code",
            "description": "Vous pouvez utiliser Cephable Intelligent Rewrite pour rédiger la documentation de votre code dans un document ou une application distinct. La réécriture fait partie des tâches d'IA sur l'appareil, notamment la génération et la traduction hors ligne."
        },
        "focusApp": {
            "title": "Concentrez-vous sur votre code",
            "description": "Ouvrez votre IDE et concentrez-vous sur le code que vous souhaitez documenter."
        },
        "newFile": {
            "title": "Créer un fichier de documentation",
            "description": "Créez un nouveau fichier dans votre IDE ou ouvrez une application distincte dans laquelle vous souhaitez que la documentation apparaisse."
        },
        "highlightText": {
            "title": "Code de surbrillance",
            "description": "Mettez en surbrillance et copiez le code que vous souhaitez documenter."
        },
        "pasteMode": {
            "title": "Cliquez sur l'onglet Coller le texte",
            "description": "Utilisez le mode Coller pour coller le code d'origine et écrire la documentation dans un nouveau fichier."
        },
        "pasteInput": {
            "title": "Coller le code dans le document",
            "description": "Collez le code que vous souhaitez documenter dans la zone de saisie."
        },
        "enterInstructions": {
            "title": "Saisissez les instructions de formatage, de style et de contenu",
            "description": "Saisissez les instructions de votre documentation de codage. Précisez le type de fichier (par exemple, Markdown), le style ou tout contenu spécifique souhaité."
        },
        "complete": {
            "description": "Vous avez appris à utiliser les tâches intelligentes pour une documentation de code rapide et sécurisée. Explorez d'autres cas d'utilisation avec la réécriture ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "generateCode": {
        "tourLabel": "Génération de code rapide et sécurisée avec génération de texte IA sur l'appareil",
        "learn": "Découvrez comment utiliser la génération basée sur l'IA pour créer des extraits de code tout en vous déplaçant entre les applications et en protégeant vos données.",
        "rewriteIntro": {
            "title": "Écrire des extraits de code",
            "description": "Vous pouvez utiliser Cephable Intelligent Rewrite pour écrire des extraits de code dans votre IDE tout en récupérant les exigences d'une autre application. La réécriture fait partie des tâches d'IA sur l'appareil, notamment la génération et la traduction hors ligne."
        },
        "focusApp": {
            "title": "Concentrez-vous sur le contenu de votre billet",
            "description": "Ouvrez votre ticket qui spécifie les exigences et concentrez-vous sur le contenu pour lequel vous souhaitez générer du code."
        },
        "newFile": {
            "title": "Créer un fichier d'extrait de code",
            "description": "Créez un nouveau fichier dans votre IDE."
        },
        "highlightText": {
            "title": "Mettre en évidence le contenu du billet",
            "description": "Mettez en surbrillance et copiez le contenu pour lequel vous souhaitez générer du code."
        },
        "pasteMode": {
            "title": "Cliquez sur l'onglet Coller le texte",
            "description": "Utilisez le mode Coller pour coller les exigences du ticket d'origine et écrire des extraits de code pour."
        },
        "pasteInput": {
            "title": "Coller les exigences pour générer du code",
            "description": "Collez les exigences que vous souhaitez utiliser pour la génération de code dans la zone de saisie."
        },
        "enterInstructions": {
            "title": "Entrez les instructions de langage et de style de programmation",
            "description": "Saisissez votre langage de programmation et vos instructions de style. Précisez le langage de programmation (par exemple, C#), le style ou toute instruction de codage spécifique."
        },
        "translateIntro": {
            "title": "Traduire des extraits de code",
            "description": "Vous pouvez également utiliser Cephable Intelligent Translate pour convertir des extraits de code d'un langage de programmation à un autre directement dans votre IDE. Translate fait partie des tâches d'IA sur l'appareil, notamment la génération et la réécriture hors ligne."
        },
        "copyGeneratedCode": {
            "title": "Copiez le code généré",
            "description": "Après avoir généré du code en suivant les étapes précédentes, mettez en surbrillance et copiez l’extrait de code généré."
        },
        "translatePasteMode": {
            "title": "Cliquez sur l'onglet Coller le texte",
            "description": "Utilisez le mode collage pour coller le code d'origine et le traduire dans un autre langage de programmation."
        },
        "enterProgrammingLanguage": {
            "title": "Entrez le langage de programmation cible",
            "description": "Tapez le langage de programmation dans lequel vous souhaitez traduire le code (par exemple Python)."
        },
        "pasteCode": {
            "title": "Collez le code généré dans votre IDE",
            "description": "Accédez à votre IDE et collez l’extrait de code copié dans le nouveau fichier que vous avez créé précédemment."
        },
        "complete": {
            "description": "Vous avez appris à utiliser les tâches intelligentes pour générer et traduire du code rapidement et en toute sécurité. Explorez d'autres cas d'utilisation avec Générer et Traduire, ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "requirementDocsFromMeeting": {
        "tourLabel": "Des notes aux documents d'exigences produit en quelques minutes",
        "learn": "Découvrez comment utiliser les tâches intelligentes de l'IA pour créer des documents d'exigences de produit structurés à partir de notes de réunion tout en gardant vos données en sécurité.",
        "rewriteIntro": {
            "title": "Créer des documents d'exigences de produit",
            "description": "Vous pouvez utiliser Cephable Intelligent Rewrite pour créer des documents d'exigences produit structurés à partir de notes de réunion. La réécriture fait partie des tâches d'IA sur l'appareil, notamment la génération et la traduction hors ligne."
        },
        "focusNotes": {
            "title": "Ouvrez vos notes de réunion",
            "description": "Ouvrez vos notes de réunion, vos transcriptions ou tout autre contenu textuel lié à la réunion."
        },
        "highlight": {
            "title": "Mettre en évidence les notes de réunion",
            "description": "Mettez en surbrillance les notes de réunion que vous souhaitez utiliser pour créer un document d’exigences produit."
        },
        "enterInstructions": {
            "title": "Saisissez les instructions relatives à la structure et au contenu du document",
            "description": "Saisissez les instructions de votre document d'exigences produit. Précisez la structure, le style ou tout contenu spécifique souhaité."
        },
        "complete": {
            "description": "Vous avez appris à utiliser les tâches intelligentes pour créer rapidement et en toute sécurité des documents d'exigences produit. Explorez d'autres cas d'utilisation avec Rewrite ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "headMouseMovement": {
        "tourLabel": "Configuration de jeu mains libres avec souris à tête",
        "learn": "Apprenez à utiliser les mouvements de la tête pour contrôler le curseur de votre souris pour une navigation et un clic précis.",
        "deviceSettings": {
            "title": "Ouvrir les paramètres de l'appareil",
            "description": "Pour activer les mouvements de la tête de la souris, cliquez sur le bouton Paramètres de l'appareil."
        },
        "cameraSettings": {
            "title": "Ouvrir les paramètres de l'appareil photo",
            "description": "Dans les paramètres de l’appareil, cliquez sur Paramètres de l’appareil photo pour accéder aux commandes de l’appareil photo."
        },
        "headMouseSection": {
            "title": "Mouvement de la tête pour les commandes de la souris",
            "description": "Lorsque cette option est activée, certaines de vos commandes de mouvement de tête seront utilisées pour déplacer votre souris au lieu des commandes de déclenchement."
        },
        "steadyGlide": {
            "title": "Mode de glissement stable",
            "description": "Activez le mode Glissement stable. Lorsque vous déplacez votre tête au-delà d'un certain point, le curseur glisse continuellement dans cette direction à vitesse constante."
        },
        "customization": {
            "title": "Personnaliser les paramètres de la tête de la souris",
            "description": "Vous pouvez personnaliser les paramètres de la tête de la souris selon vos préférences. Ajustez la vitesse, la sensibilité et d'autres paramètres pour une expérience optimale."
        },
        "save": {
            "title": "Enregistrer les paramètres de la tête de la souris",
            "description": "N'oubliez pas d'enregistrer vos paramètres de souris de tête personnalisés."
        },
        "transition": {
            "title": "Passage au panneau Cephable",
            "description": "Passons maintenant au panneau Cephable pour tester les mouvements de la tête de la souris."
        },
        "playGames": {
            "title": "Jouez à des jeux avec la souris principale",
            "description": "Vous pouvez désormais utiliser les mouvements de la tête pour contrôler le curseur de votre souris pendant vos jeux. Essayez-le et découvrez son fonctionnement !"
        }
    },
    "clinicalNoteTaking": {
        "tourLabel": "Dictée et formatage conformes à la loi HIPAA pour les cliniciens",
        "learn": "Apprenez à utiliser les commandes vocales, la dictée intelligente et le formatage IA pour prendre des notes cliniques.",
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sélectionné. Par exemple, dites : « Le patient est un homme de 45 ans ayant des antécédents d’hypertension. Le dernier médicament prescrit n’a pas eu l’effet escompté et a provoqué une réaction allergique. Nous allons devoir envisager des médecines alternatives et souhaiterions une ordonnance générique. »"
        },
        "rewriteIntro": {
            "title": "Formatez vos notes",
            "description": "Vous pouvez désormais utiliser Cephable Intelligent Rewrite pour formater vos notes selon le format SOAP. L'opération s'effectue directement sur l'appareil, ce qui garantit la confidentialité, la sécurité et la conformité HIPAA de vos données."
        },
        "copyText": {
            "title": "Copier les notes",
            "description": "Après avoir surligné vos notes, copiez le texte pour le préparer à la mise en forme."
        },
        "pasteMode": {
            "title": "Cliquez sur l'onglet Coller le texte",
            "description": "Utilisez le mode Coller pour coller les notes originales et les formater dans le style SOAP."
        },
        "pasteInput": {
            "title": "Coller des notes au format",
            "description": "Collez les notes que vous souhaitez formater dans la zone de saisie."
        },
        "enterInstructions": {
            "title": "Saisissez les instructions de formatage",
            "description": "Vous pouvez rédiger des instructions de mise en forme qui devront être respectées pour votre clinique/système DSE. (Par exemple, formater au format SOAP avec des titres, des puces et un langage concis.)"
        },
        "navigateToEHR": {
            "title": "Accédez à votre système DSE",
            "description": "Ouvrez votre système DSE et accédez à la section dans laquelle vous souhaitez saisir les notes formatées."
        },
        "focusTextField": {
            "title": "Concentrez-vous sur le champ de texte",
            "description": "Cliquez sur le champ de texte dans lequel vous souhaitez coller les notes formatées."
        },
        "complete": {
            "description": "Vous avez appris à utiliser les commandes vocales et la dictée intelligente pour documenter vos notes cliniques, ainsi que la réécriture intelligente pour les formater selon le format SOAP. Explorez d'autres cas d'utilisation avec la dictée et la réécriture, ou d'autres fonctionnalités pour optimiser votre flux de travail."
        },
        "focus": {
            "title": "Se concentrer sur un document",
            "description": "La dictée est plus efficace lorsque vous vous concentrez sur un document. Ouvrez un document dans lequel vous souhaitez prendre des notes cliniques entre les séances."
        }
    },
    "webBrowsing": {
        "tourLabel": "Planifiez des voyages, faites des achats en ligne et naviguez sur le Web à l'aide de la voix",
        "learn": "Apprenez à utiliser les commandes vocales pour naviguer, faire défiler et remplir des formulaires tout en naviguant sur le Web en mains libres.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Chrome » ou « Ouvrir Edge »",
            "description": "Assurez-vous que votre microphone est activé et dites « Ouvrir Chrome » ou « Ouvrir Edge ». Cela ouvrira le navigateur web de votre choix. Si le changement automatique de contrôle est activé, les contrôles correspondant le mieux à l'application que vous utilisez seront également activés."
        },
        "search": {
            "title": "Recherche",
            "description": "Essayez de dire « Rechercher » ou « Rechercher ». Cela activera la barre de recherche de votre navigateur."
        },
        "quickType": {
            "title": "Saisie rapide",
            "description": "La saisie rapide vous permet de saisir du texte à la voix sans passer en mode dictée. Dites « Quel temps fait-il aujourd'hui ? » Votre requête sera alors saisie dans la barre de recherche."
        },
        "enter": {
            "title": "Appuyez sur Entrée",
            "description": "Essayez de dire « Entrée ». Cela exécutera la requête de recherche que vous venez de saisir."
        },
        "scrollDown": {
            "title": "Faites défiler vers le bas",
            "description": "Essayez de dire « Défiler vers le bas ». Cela fera défiler la page web vers le bas."
        },
        "scrollUp": {
            "title": "Faites défiler vers le haut",
            "description": "Essayez de dire « Défiler vers le haut ». Cela fera défiler la page vers le haut."
        },
        "newTab": {
            "title": "Ouvrir un nouvel onglet",
            "description": "Essayez de dire « Nouvel onglet ». Cela ouvrira un nouvel onglet dans votre navigateur."
        },
        "formsCustomization": {
            "title": "Personnalisation du remplissage de formulaires",
            "description": "Vous pouvez personnaliser cette application pour faciliter le remplissage des formulaires. Par exemple, ajoutez votre prénom, votre nom, votre adresse e-mail, etc. Utilisez ensuite les actions rapides ou les commandes vocales pour remplir les formulaires encore plus rapidement."
        },
        "complete": {
            "title": "Bon travail !",
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour naviguer, rechercher, faire défiler et remplir des formulaires sur le Web. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour une navigation encore plus fluide."
        }
    },
    "spreadsheetReviews": {
        "tourLabel": "Travaillez plus rapidement dans les feuilles de calcul grâce aux commandes vocales",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour consulter et modifier rapidement de grandes feuilles de calcul.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Excel » ou « Ouvrir Google Sheets »",
            "description": "Assurez-vous que votre microphone est activé et dites « Ouvrir Excel » ou « Ouvrir Google Sheets ». Cela ouvrira l'application de tableur de votre choix. Si le changement automatique des commandes est activé, les commandes correspondant le mieux à l'application que vous utilisez seront également activées."
        },
        "selectRow": {
            "title": "Sélectionnez une ligne",
            "description": "Cliquez sur une cellule. Ensuite, essayez de dire « Sélectionner une ligne ». Cela sélectionnera la ligne entière de la cellule ciblée."
        },
        "delete": {
            "title": "Supprimer le contenu d'une ligne",
            "description": "Essayez de dire « Supprimer ». Cela supprimera le contenu de la ligne sélectionnée."
        },
        "note": {
            "title": "Ajouter une note à une cellule",
            "description": "Cliquez sur une cellule. Ensuite, essayez de dire « Ajouter une note ». Cela vous permettra d'ajouter une note à la cellule ciblée."
        },
        "addNote": {
            "title": "Tapez la note",
            "description": "Essayez de dire « Saisissez ces chiffres qui ne correspondent pas ». Votre note sera alors saisie dans la cellule."
        },
        "currentDate": {
            "title": "Entrez la date actuelle",
            "description": "Cliquez sur une cellule. Ensuite, essayez de dire « Date du jour ». La date du jour sera alors inscrite dans la cellule ciblée."
        },
        "copy": {
            "title": "Copier une cellule",
            "description": "Cliquez sur la cellule à laquelle vous venez d'ajouter la date du jour. Ensuite, essayez de dire « Copier ». Cela copiera la date du jour."
        },
        "selectColumn": {
            "title": "Sélectionnez une colonne",
            "description": "Essayez de dire « Colonne ». Cela sélectionnera toute la colonne pour la cellule ciblée."
        },
        "paste": {
            "title": "Coller la date actuelle",
            "description": "Essayez de dire « Coller ». Cela collera la date du jour dans la colonne sélectionnée."
        },
        "quickActions": {
            "title": "Utiliser les actions rapides",
            "description": "Vous pouvez également effectuer bon nombre de ces commandes et bien d'autres encore grâce aux boutons d'action rapide. Vous pouvez personnaliser ces boutons pour les adapter à votre flux de travail et accélérer encore la révision et la modification des feuilles de calcul."
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour consulter et modifier rapidement de grandes feuilles de calcul. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour une gestion plus rapide de vos feuilles de calcul."
        }
    },
    "socialMediaWriting": {
        "tourLabel": "Créez, itérez et publiez du contenu sur les réseaux sociaux avec la voix et l'IA sur l'appareil",
        "learn": "Apprenez à utiliser Intelligent Generate and Rewrite, entièrement privé et sur l'appareil, pour créer et itérer sur du contenu.",
        "onDeviceIntro": {
            "title": "Vos recherches restent privées et sécurisées",
            "description": "Les tâches intelligentes de Cephable sont optimisées par l'IA intégrée à l'appareil, garantissant la confidentialité et la sécurité de vos données. Vous pouvez créer, réécrire et traduire du texte sans aucun traitement cloud. Vous pouvez également exploiter le contexte inter-applications et itérer sur des idées directement dans votre application préférée."
        },
        "enterPrompt": {
            "title": "Commencez à imaginer",
            "description": "Dans la zone de saisie, saisissez le contenu que vous souhaitez structurer ou générer. Par exemple, vous pouvez saisir : « Énumérer les risques liés à l'IA agentique, identifier les lacunes et comment l'innovation peut progresser. »"
        },
        "customizeSettings": {
            "title": "Personnaliser les paramètres de génération",
            "description": "Personnalisez les paramètres de génération selon vos préférences. Ajustez-les grâce aux invites système qui reflètent le ton, la voix de la marque, etc."
        },
        "rewriteIntro": {
            "title": "Itérer sur le contenu",
            "description": "Vous pouvez utiliser Cephable Intelligent Rewrite pour itérer le contenu directement dans votre application préférée. Tout se fait sur l'appareil, ce qui garantit la confidentialité et la sécurité de vos données."
        },
        "highlightText": {
            "title": "Surligner le texte à réécrire",
            "description": "Mettez en surbrillance l’un des risques répertoriés à partir du contenu généré sur lequel vous souhaitez poursuivre vos itérations."
        },
        "enterInstructions": {
            "title": "Entrez les instructions de réécriture",
            "description": "Saisissez vos instructions de réécriture. Par exemple, vous pouvez saisir : « Ajouter plus de détails sur les risques »."
        },
        "writeSocialMediaPost": {
            "title": "Rédiger une publication sur les réseaux sociaux",
            "description": "Utilisez à nouveau la réécriture pour reformater ce langage dans une publication sur les réseaux sociaux destinée au public qui obtient les points clés et met en évidence les domaines d'engagement."
        },
        "highlightPost": {
            "title": "Mettre en évidence la publication générée",
            "description": "Mettez en surbrillance la publication sur les réseaux sociaux générée que vous souhaitez utiliser."
        },
        "enterPostInstructions": {
            "title": "Entrez les instructions de publication",
            "description": "Saisissez les instructions de votre publication. Par exemple : « Soyez concis et engageant pour LinkedIn. »"
        },
        "complete": {
            "description": "Vous pouvez maintenant ouvrir votre plateforme de médias sociaux préférée, vous concentrer sur la zone de création de publication et coller la publication générée. Vous pouvez également continuer à peaufiner et à peaufiner jusqu'à ce que vous soyez prêt !"
        }
    },
    "inboxTriage": {
        "tourLabel": "Gestion efficace des e-mails avec la voix et l'IA sur l'appareil",
        "learn": "Apprenez à utiliser les commandes vocales et les tâches intelligentes pour gérer efficacement votre boîte de réception tout en protégeant vos données.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Outlook » ou « Ouvrir Gmail »",
            "description": "Assurez-vous que votre microphone est activé et dites « Ouvrir Outlook » ou « Ouvrir Gmail ». Cela ouvrira l'application de messagerie de votre choix. Si le changement automatique de contrôle est activé, les contrôles correspondant le mieux à l'application que vous utilisez seront également activés."
        },
        "select": {
            "title": "Sélectionnez une adresse e-mail",
            "description": "Cliquez sur un e-mail. Ensuite, essayez de dire « Sélectionner un e-mail ». Cela sélectionnera l'e-mail ciblé."
        },
        "delete": {
            "title": "Supprimer un e-mail",
            "description": "Essayez de dire « Supprimer ». Cela supprimera l'e-mail sélectionné."
        },
        "reply": {
            "title": "Répondre à un e-mail",
            "description": "Cliquez sur un e-mail. Ensuite, essayez de dire « Répondre ». Cela ouvrira la fenêtre de réponse à l'e-mail ciblé."
        },
        "dictateIntro": {
            "title": "Dictez votre réponse",
            "description": "Vous pouvez utiliser la dictée pour saisir votre réponse en mode mains libres. Assurez-vous que votre microphone est allumé et que le mode dictée est activé."
        },
        "dictateReply": {
            "title": "Commencer à répondre",
            "description": "Essayez de dire : « Je souhaite en savoir plus sur vos services. Veuillez m'envoyer des informations complémentaires. » Cela permettra de rédiger votre réponse dans l'e-mail. Assurez-vous de bien vous concentrer sur la zone de texte de réponse."
        },
        "newEmail": {
            "title": "Créer un nouvel e-mail",
            "description": "Essayez de dire « Nouvel e-mail ». Cela ouvrira une nouvelle fenêtre de rédaction d'e-mail."
        },
        "customEmailTemplates": {
            "title": "Modèles d'e-mails personnalisés",
            "description": "Vous pouvez créer des modèles d'e-mails personnalisés pour les réponses courantes. Cela vous permettra d'insérer rapidement du contenu pré-rédigé dans vos e-mails grâce à des commandes vocales ou des actions rapides."
        },
        "editAppControls": {
            "title": "Modifier les contrôles de l'application",
            "description": "Pour créer un modèle d’e-mail personnalisé, cliquez sur le bouton Modifier les contrôles de l’application."
        },
        "addNewControl": {
            "title": "Ajouter un nouveau contrôle",
            "description": "Dans l’éditeur de contrôles d’application, cliquez sur le bouton Ajouter un nouveau contrôle."
        },
        "quickAction": {
            "title": "Sélectionnez Action rapide",
            "description": "Choisissez Action rapide comme type de contrôle."
        },
        "templateName": {
            "title": "Nommez votre modèle",
            "description": "Donnez un nom à votre modèle d’e-mail personnalisé, par exemple « Demande de réunion »."
        },
        "eventType": {
            "title": "Sélectionnez le type d'événement",
            "description": "Dans la section type d'événement, choisissez un type d'événement « type »."
        },
        "typeSteps": {
            "title": "Type de contenu du modèle",
            "description": "Saisissez le contenu de votre modèle d'e-mail. Par exemple : « Relations avec les prospects\nBonjour, je souhaiterais organiser une réunion pour discuter d'éventuelles collaborations. Veuillez me faire part de vos disponibilités. »"
        },
        "finish": {
            "title": "Terminer la création du modèle",
            "description": "Cliquez sur le bouton Terminer pour terminer la création de votre modèle d’e-mail personnalisé."
        },
        "saveTemplate": {
            "title": "Enregistrez votre modèle",
            "description": "Cliquez sur le bouton Enregistrer pour enregistrer votre modèle d’e-mail personnalisé."
        },
        "focusApp": {
            "title": "Recentrez-vous sur votre application de messagerie",
            "description": "Revenez à votre application de messagerie et assurez-vous que vous vous concentrez sur la nouvelle ligne d’objet de l’e-mail."
        },
        "useTemplate": {
            "title": "Utilisez votre modèle",
            "description": "Vous pouvez désormais utiliser votre modèle d’e-mail personnalisé en prononçant son nom ou en cliquant sur le bouton Action rapide."
        },
        "generateIntro": {
            "title": "Générer du contenu d'e-mail",
            "description": "Vous pouvez également utiliser Cephable Intelligent Generate pour créer du contenu d'e-mail directement dans votre application de messagerie. Tout se fait sur l'appareil, ce qui garantit la confidentialité et la sécurité de vos données."
        },
        "enterPrompt": {
            "title": "Entrez l'invite de courrier électronique",
            "description": "Dans la boîte de dialogue, saisissez : Rédigez un e-mail professionnel à un client potentiel présentant nos services et demandant un rendez-vous."
        },
        "focusNewEmail": {
            "title": "Concentrez-vous sur le nouvel e-mail",
            "description": "Assurez-vous que vous êtes concentré sur la nouvelle fenêtre de composition de courrier électronique dans laquelle vous souhaitez que le texte généré apparaisse."
        },
        "translateEmail": {
            "title": "Traduire le contenu des e-mails",
            "description": "Vous pouvez utiliser Cephable Intelligent Translate pour traduire le contenu de vos e-mails directement dans votre application de messagerie. Tout s'effectue sur l'appareil, ce qui garantit la confidentialité et la sécurité de vos données."
        },
        "highlightText": {
            "title": "Mettre en évidence le contenu de l'e-mail",
            "description": "Mettez en surbrillance le contenu d’un long e-mail que vous souhaitez traduire."
        },
        "enterLanguage": {
            "title": "Entrez la langue de traduction",
            "description": "Saisissez votre langue de traduction. Par exemple : « Espagnol »."
        },
        "complete": {
            "description": "Vous savez désormais utiliser les commandes vocales et les tâches intelligentes pour parcourir, répondre, dicter, générer et traduire des e-mails tout en protégeant vos données. Explorez d'autres commandes ou personnalisez vos actions rapides pour une gestion des e-mails encore plus fluide."
        }
    },
    "handsFreeMeeting": {
        "tourLabel": "Commandes rapides de réunion mains libres",
        "learn": "Gagnez du temps et réduisez la fatigue des réunions virtuelles grâce aux commandes rapides des réunions mains libres",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Zoom » ou « Ouvrir Teams »",
            "description": "Assurez-vous que votre microphone est activé et dites « Ouvrir Zoom » ou « Ouvrir Teams ». L'application de réunion sélectionnée s'ouvrira. Si le changement automatique de contrôle est activé, les contrôles correspondant à l'application que vous utilisez seront également activés."
        },
        "mute": {
            "title": "Essayez de dire « Basculer en mode muet » pour couper votre microphone",
            "description": "Assurez-vous que votre microphone est activé et dites « Désactiver le son ». Cela désactivera votre microphone dans l'application de réunion choisie."
        },
        "video": {
            "title": "Essayez de dire « Basculer la vidéo » pour allumer ou éteindre votre caméra",
            "description": "Assurez-vous que votre microphone est activé et dites « Activer/Désactiver la vidéo ». Cela activera ou désactivera votre caméra dans l'application de réunion choisie."
        },
        "raiseHand": {
            "title": "Essayez de dire « Lever la main » pour lever la main",
            "description": "Assurez-vous que votre micro est activé et dites « Lever la main ». Votre main sera levée dans l'application de réunion de votre choix."
        },
        "quickType": {
            "title": "Saisie rapide",
            "description": "Assurez-vous que votre microphone est activé et dites « Tapez, c'est une fonctionnalité intéressante ». Cela vous permettra de saisir rapidement du texte à la voix sans passer en mode dictée. Assurez-vous d'être concentré sur un champ de texte dans votre application de réunion."
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour activer/désactiver le son, activer/désactiver la vidéo, lever la main et saisir rapidement des messages dans vos applications de réunion préférées. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour un contrôle encore plus fluide de vos réunions."
        }
    },
    "summarizingReports": {
        "tourLabel": "Résumez les rapports et les documents avec l'IA sur l'appareil",
        "learn": "Apprenez à utiliser le résumé basé sur l'IA pour obtenir rapidement les points clés de longs rapports et documents tout en préservant la sécurité de vos données confidentielles et exclusives.",
        "summarizeIntro": {
            "title": "Résumer le texte",
            "description": "Vous pouvez utiliser les tâches intelligentes Cephable pour extraire rapidement les points clés de longs rapports et documents. Summarize fait partie des tâches IA sur appareil, ce qui signifie qu'il fonctionne sans connexion Internet et directement sur votre appareil."
        },
        "navigateToReport": {
            "title": "Concentrez-vous sur votre rapport ou document",
            "description": "Ouvrez votre rapport ou document dans votre application préférée et concentrez-vous sur le texte que vous souhaitez résumer."
        },
        "highlightText": {
            "title": "Surligner le texte pour le résumer",
            "description": "Surlignez le texte que vous souhaitez résumer."
        },
        "copyText": {
            "title": "Copier le texte",
            "description": "Après avoir surligné votre texte, copiez-le pour le préparer au résumé."
        },
        "enterPrompt": {
            "title": "Saisissez les instructions de résumé",
            "description": "Saisissez vos instructions de résumé. Précisez la longueur, le style ou tout contenu spécifique souhaité."
        },
        "pasteText": {
            "title": "Collez le contenu de votre rapport",
            "description": "Après les instructions, collez le texte copié dans la zone de saisie."
        },
        "focusChatApp": {
            "title": "Concentrez-vous sur votre application de chat",
            "description": "Ouvrez votre application de chat comme Teams ou Slack et concentrez-vous sur la zone de texte dans laquelle vous souhaitez que le texte résumé apparaisse."
        },
        "rewriteIntro": {
            "title": "Réécrire le texte résumé",
            "description": "Vous pouvez également utiliser Cephable Intelligent Rewrite pour affiner le texte résumé. Tout cela s'effectue sur l'appareil, ce qui garantit la confidentialité et la sécurité de vos données."
        },
        "highlightSummary": {
            "title": "Surlignez le texte résumé",
            "description": "Mettez en surbrillance le texte résumé que vous souhaitez affiner davantage."
        },
        "enterRewriteInstructions": {
            "title": "Entrez les instructions de réécriture",
            "description": "Saisissez vos instructions de réécriture. Précisez le ton, le style ou toute modification spécifique souhaitée."
        },
        "complete": {
            "description": "Vous avez appris à utiliser les tâches intelligentes pour synthétiser rapidement et en toute sécurité vos textes et partager vos résultats avec votre équipe. Explorez d'autres cas d'utilisation avec « Summarize » et « Rewrite », ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "congrats": "Bravo!",
    "noteTakingAndDocumentation": {
        "tourLabel": "Prise de notes et génération de documents à l'aide d'une IA privée sur l'appareil",
        "learn": "Apprenez à utiliser les commandes vocales, la dictée intelligente et les tâches IA pour passer plus rapidement des notes aux conceptions et aux documents.",
        "focus": {
            "title": "Se concentrer sur un champ de texte ou un document",
            "description": "La dictée est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Ouvrez un document ou cliquez sur le champ de texte où vous souhaitez prendre des notes."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Pendant que vous réfléchissez à votre idée, parlez naturellement et laissez libre cours à vos pensées. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous êtes concentré. Essayez de décrire votre concept, de décrire les étapes ou de lancer une réflexion libre. Par exemple, dites : « J’envisage un nouveau flux de travail pour notre équipe. Nous devrions d’abord automatiser le processus de reporting, puis examiner les résultats chaque semaine. » Assurez-vous que votre curseur est bien positionné sur le document."
        },
        "typeEnter": {
            "title": "Sauts de paragraphe",
            "description": "Pour créer des sauts de paragraphe, appuyez simplement sur Entrée sur votre clavier. Cela vous permettra d'organiser vos notes en sections claires. Continuez à exprimer vos pensées ou à retranscrire les propos d'une autre personne."
        },
        "rewriteIntro": {
            "title": "Créer des designs",
            "description": "Vous pouvez désormais utiliser Cephable Intelligent Rewrite pour prendre vos notes et les transformer en idées de fonctionnalités ou en suivis. Tout se fait sur votre appareil, garantissant ainsi la confidentialité et la sécurité de vos données."
        },
        "highlightText": {
            "title": "Surligner les notes",
            "description": "Sélectionnez toutes les notes que vous souhaitez utiliser pour créer une conception ou un document."
        },
        "inPlaceReplacement": {
            "title": "Idéation sur place",
            "description": "Nous allons maintenant utiliser le remplacement sur place pour transformer vos notes en modèle ou en document. Vous pouvez également utiliser le mode Coller ou l'option permettant de créer un nouveau fichier."
        },
        "enterInstructions": {
            "title": "Entrez les instructions de conception",
            "description": "Vous pouvez rédiger vos instructions pour les prochaines étapes, en précisant ce que vous souhaitez faire avec ces notes. Il peut s'agir de mise en forme, de conception, de suivi, etc. (Par exemple, créez un document de conception décrivant le fonctionnement de la fonctionnalité, son aspect final et les conditions de réussite potentielles.)"
        },
        "complete": {
            "description": "Vous avez appris à utiliser les commandes vocales et la dictée intelligente pour documenter vos notes cliniques, ainsi que la réécriture intelligente pour les formater selon le format SOAP. Explorez d'autres cas d'utilisation avec la dictée et la réécriture, ou d'autres fonctionnalités pour optimiser votre flux de travail."
        }
    },
    "fpsGamePlay": {
        "tourLabel": "Jouez à des jeux FPS avec des commandes vocales",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour jouer à des jeux FPS.",
        "changeProfile": {
            "title": "Profil de contrôle des modifications",
            "description": "Modifiez le contrôle de votre application pour le profil de jeu FPS. Vous pouvez également le personnaliser pour le jeu auquel vous souhaitez jouer. Consultez la vidéo."
        },
        "autoProfileSwitching": {
            "title": "Désactiver la commutation de contrôle automatique",
            "description": "Cela gardera votre contrôle d'application actuel actif jusqu'à ce que vous changiez d'application."
        },
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Valorant » ou « Ouvrir Battlefield »"
        },
        "go": {
            "title": "Essayez de dire « Allez »",
            "description": "Assurez-vous que votre micro est allumé et dites « Go ». Votre personnage avancera."
        },
        "stop": {
            "title": "Essayez de dire « Stop »",
            "description": "Assurez-vous que votre micro est allumé et dites « Stop ». Cela arrêtera de bouger votre personnage."
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour déplacer, arrêter et contrôler votre personnage dans les jeux FPS. Explorez d'autres commandes ou personnalisez vos actions rapides pour un gameplay encore plus fluide et rapide."
        }
    },
    "presentationControls": {
        "tourLabel": "Contrôler les présentations avec des commandes vocales",
        "learn": "Découvrez comment utiliser les commandes vocales et les actions rapides pour naviguer et contrôler vos présentations en mains libres.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir PowerPoint » ou « Ouvrir Google Slides »"
        },
        "startPresentation": {
            "title": "Essayez de dire « Démarrer la présentation » pour démarrer votre diaporama",
            "description": "Assurez-vous que votre microphone est activé et dites « Démarrer la présentation ». Votre diaporama démarrera dans l'application de présentation de votre choix."
        },
        "nextSlide": {
            "title": "Essayez de dire « Diapositive suivante » pour passer à la diapositive suivante",
            "description": "Assurez-vous que votre micro est activé et dites « Diapositive suivante ». Cela vous permettra de passer à la diapositive suivante de votre diaporama."
        },
        "previousSlide": {
            "title": "Essayez de dire « Diapositive précédente » pour revenir à la diapositive précédente",
            "description": "Assurez-vous que votre micro est activé et dites « Diapositive précédente ». Cela vous ramènera à la diapositive précédente de votre diaporama."
        },
        "escape": {
            "title": "Essayez de dire « Échap » pour quitter le mode de présentation",
            "description": "Assurez-vous que votre microphone est activé et dites « Échap ». Cela quittera le mode présentation dans l'application de présentation choisie."
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour démarrer, naviguer et quitter des présentations en mode mains libres. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour un contrôle encore plus fluide de vos présentations."
        }
    },
    "editingImages": {
        "tourLabel": "Édition d'images plus rapide grâce aux commandes vocales et à la dictée",
        "learn": "Apprenez à utiliser les commandes vocales, les actions rapides et la dictée pour améliorer votre processus d’édition d’images.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Figma » ou « Ouvrir Photoshop »"
        },
        "selectAll": {
            "title": "Essayez de dire « Sélectionner tout » pour sélectionner tous les éléments sur le canevas",
            "description": "Assurez-vous que votre microphone est activé et dites « Sélectionner tout ». Cela sélectionnera tous les éléments de la zone de travail dans l'application de retouche d'image de votre choix. Assurez-vous d'être concentré sur l'application."
        },
        "bold": {
            "title": "Essayez de dire « Gras » pour mettre le texte sélectionné en gras",
            "description": "Assurez-vous que votre microphone est activé et dites « Gras ». Le texte sélectionné sera mis en gras dans l'application de retouche d'image de votre choix. Assurez-vous que le texte est sélectionné."
        },
        "copy": {
            "title": "Essayez de dire « Copier » pour copier l'élément sélectionné",
            "description": "Assurez-vous que votre microphone est activé et dites « Copier ». Cela copiera l'élément sélectionné dans l'application de retouche d'image de votre choix. Assurez-vous d'avoir sélectionné un élément."
        },
        "paste": {
            "title": "Essayez de dire « Coller » pour coller l'élément copié",
            "description": "Assurez-vous que votre microphone est activé et dites « Coller ». L'élément copié sera alors collé dans l'application de retouche d'image de votre choix."
        },
        "delete": {
            "title": "Essayez de dire « Supprimer » pour supprimer l'élément sélectionné",
            "description": "Assurez-vous que votre microphone est activé et dites « Supprimer ». Cela supprimera l'élément sélectionné dans l'application de retouche d'image choisie. Assurez-vous d'avoir sélectionné un élément."
        },
        "dictationIntro": {
            "title": "Dictée",
            "description": "Vous pouvez utiliser la dictée pour saisir du texte avec votre voix. Assurez-vous que votre microphone est allumé et que le mode dictée est activé."
        },
        "focus": {
            "title": "Focus sur un champ de texte",
            "description": "Cliquez sur un champ de texte dans votre application de retouche d’image dans lequel vous souhaitez utiliser la dictée."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Essayez de dire : « Pour obtenir des codes de réduction anticipés, scannez le code QR. Valable jusqu'au 30 septembre. Ensuite, faites votre demande sur le site web. » Assurez-vous de bien cibler le champ de texte ou la zone où vous souhaitez dicter."
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales, les actions rapides et la dictée pour améliorer votre processus de retouche d'images. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour une retouche encore plus fluide."
        }
    },
    "redo": "Refaire l'intégration",
    "title": "Découvrez Cephable",
    "description": "Découvrez Cephable, votre assistant IA personnel et partagez votre intérêt pour les cas d'utilisation personnalisés."
}
